import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function DepotsAPI(): BringozApi {
  return {
    base: `/depots`,
    infiniteScroll: {
      address: `/depots`,
      cmd: 'GET'
    },
    actions: {
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteDepot: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      addBranchesToDepots: {
        address: 'addBranches',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}

angular
  .module('bringoz.admin.depots')
  .factory('depotsAPI', DepotsAPI);
